import { Navigate, Route, Routes } from 'react-router-dom'

import { AcceptTerms } from '../../../pages/expert/AcceptTerms'
import { ForgotPassword } from '../../../pages/expert/ForgotPassword'
import { Login } from '../../../pages/expert/Login'
import { RegisterPassword } from '../../../pages/expert/RegisterPassword'
import { ResetPassword } from '../../../pages/expert/ResetPassword'
import { StepRegistration } from '../../../pages/expert/StepRegistration'
import { PersonalDataStep } from '../../../pages/expert/StepRegistration/PersonalDataStep'
import { TermsStep } from '../../../pages/expert/StepRegistration/TermsStep'
import { Root } from './Root'

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route element={<Root />}>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="register-password" element={<RegisterPassword />} />
        <Route path="accept-terms" element={<AcceptTerms />} />

        <Route path="register" element={<StepRegistration />}>
          <Route index element={<PersonalDataStep />} />
          <Route path="terms" element={<TermsStep />} />
        </Route>
        <Route path="*" element={<Navigate to={'/expert'} />} />

        <Route index element={<Login />} />
      </Route>
    </Routes>
  )
}
